<template>
    <div class="form-group mod">
        <label :for="id" class="form-label" :class="{ require: required }">
            {{ title }}
        </label>
        <input
            :type="isFirefox ? 'date' : 'datetime-local'"
            class="form-control"
            :id="id"
            :placeholder="placeholder"
            v-model="defaultValue"
            @change="getDate"
            :disabled="disabled"
        />
        <input
            v-if="isFirefox"
            type="time"
            class="form-control mt-1"
            v-model="time"
            @change="getDate"
            required
            :disabled="disabled"
        >
    </div>
</template>

<script>
export default {
    name: "SOInputDateTime",
    props: {
        title: String,
        id: String,
        placeholder: String,
        value: String,
        minDate: String,
        maxDate: String,
        required: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            defaultValue: "",
            time: "",
            isFirefox: typeof InstallTrigger !== 'undefined',
        };
    },
    mounted() {
        if (this.maxDate) {
            this.setMaxDate();
        }
        if (this.minDate) {
            this.setMinDate();
        }
        if (this.value) {
            this.defaultValue = this.value;
            this.$emit('get-date', this.defaultValue);
            this.time = this.isFirefox ? this.value.split(" ")[1] : "";
        }
    },
    // updated() {
    //     if (this.value) {
    //         this.defaultValue = this.value;
    //     }
    // },
    watch: {
        minDate: {
            handler: function() {
                this.minDate !== "" ? this.setMinDate() : this.removeMinDate();
            },
        },
        maxDate: {
            handler: function() {
                this.maxDate !== "" ? this.setMaxDate() : this.removeMaxDate();
            },
        },
        value: function(newVal, oldVal) {
            if (newVal !== oldVal && !oldVal) {
                this.$forceUpdate();
            }
        },
    },
    methods: {
        getDate() {
            if (this.isFirefox) {
                this.$emit("get-date", this.defaultValue + "T" + this.time);
            }
            else {
                this.$emit("get-date", this.defaultValue);
            }
        },
        setMaxDate() {
            const date = this.maxDate.split("T");
            $("#" + this.id).attr("max", this.isFirefox ? date[0] : this.maxDate);
        },
        removeMaxDate() {
            $("#" + this.id).attr("max", null);
        },
        setMinDate() {
            const date = this.minDate.split("T");
            $("#" + this.id).attr("min", this.isFirefox ? date[0] : this.minDate);
        },
        removeMinDate() {
            $("#" + this.id).attr("min", null);
        },
    },
};
</script>
